module.exports = __webpack_public_path__ + "img/python.7cc4249d.svg";